define('viewmodels/AuthorizeMFA',['plugins/router', 'services/appsecurity', 'services/navigation', 'services/logger', 'services/AppRoutes', 'durandal/system', 'services/routeconfig'],
    function (router, appsecurity, navigation, logger, AppRoutes, system, routeconfig) {
        var title = 'MFA Authorize';
        var vm = {
            activate: function () {
            },
            appsecurity: appsecurity,
            AppRoutes: AppRoutes,
            attached: attached,
            detached: detached,
            ClientDetails: ko.observableArray([]),
            imagePath: ko.observable(),
            SubmitOnetimepassword: SubmitOnetimepassword,
            ControlsAccess: ko.observable(),
            OTPPassword: ko.observable(),
            ResendOTP: ResendOTP,
            ProviderName: ko.observable('SMSCode'),
            Wrongattemptcount: ko.observable(3),
            howtoText: ko.observable('how do you want us to verify your account ?'),
            OtpValidationText: ko.observable(),
            CreateOneTimePassword: CreateOneTimePassword,
            PhoneNumber: ko.observable(),
            MaskedNumber: ko.observable(),
            EnteredPhoneNumber: ko.observable(),
            VerifyPhoneNumeber: VerifyPhoneNumeber,
            Logout: Logout,
            verifyUserwithPhonecall: verifyUserwithPhonecall,
            OtpText: ko.observable('We\'ve sent you a text message on'),
            displayMessage: ko.observable(),
            ShowGeneralManual: ShowGeneralManual,
            ContactUsContent: ko.observable(''),
            UserContent: ko.observable(),
        };
        return vm;

        function attached() {
            try {
                $('#MessageDiv').show();
                $('#loginPageLogo').hide();
                $('#loadingMainImgDiv').hide();
                //$("body").removeClass("login-page").addClass("login-container");
                //$('body').addClass("login hold-transition");
                $("body").removeClass("login-page");
                $('body').addClass("hold-transition");
                $('.main-header').hide();
                $('.main-sidebar').hide();
                $("#master-header-content").removeClass("content-wrapper");

                DefaultButton =
                    $("header").css({ "display": "none" });
                $('.static-header').show();
                $('#loginPageLogo').hide();
                $("#numberprovider").intlTelInput({
                    allowExtensions: true,
                    autoFormat: false,
                    autoHideDialCode: false,
                    autoPlaceholder: false,
                    defaultCountry: "auto",
                    ipinfoToken: "yolo",
                    nationalMode: false,
                    numberType: "MOBILE",
                    //onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
                    //preferredCountries: ['cn', 'jp'],
                    preventInvalidNumbers: true,
                });
                //if (appsecurity.Phonenumberverified() == "False") {
                //    ShowPhoneNumberEntry();

                //}
                //else {
                //GetPhoneNumber();
                //$('#MessageDiv').show();
                $('#PhoneNumeberdiv').hide();
                $('#AuthenticateDiv').hide();
                $('#loginPageLogo').hide();
                //}
                if (vm.appsecurity.ContanctUs() == undefined || vm.appsecurity.ContanctUs() == '') {
                    GetContactUsInformation();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }
        function Logout() {
            try {
                if (vm.appsecurity != undefined && vm.appsecurity.userInfo() != undefined) {
                    vm.appsecurity.logout()
                        .done(function (token) {
                            $("input[name='__RequestVerificationToken']").val(token);
                            appsecurity.clearAuthInfo();
                            window.location = routeconfig.login;
                        })
                        .fail(function (error) {
                            appsecurity.clearAuthInfo();
                            window.location = routeconfig.login;
                        });
                } else {
                    window.location = routeconfig.login;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: Logout() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }

        function VerifyPhoneNumeber(data, event) {
            try {
                if ($("#numberprovider").intlTelInput("isValidNumber")) {
                    $('#phonenumbervalidation').hide();
                    $('#loadingMainImgDiv').hide();
                    var Countrycode = "+" + $("#numberprovider").intlTelInput("getSelectedCountryData").dialCode;
                    var number = $("#numberprovider").intlTelInput("getNumber");
                    number = number.substring(Countrycode.length, number.length);
                    vm.PhoneNumber(Countrycode + "-" + number)
                    $('#MessageDiv').show();
                    $('#PhoneNumeberdiv').hide();
                    var totallength = number.substring(number.length - 3, number.length);
                    var countrycode = Countrycode + "-" + number.substring(0, 2);
                    var completenumber = countrycode + "*****" + totallength;
                    vm.MaskedNumber(completenumber);
                    vm.OtpText('How should we send the MFA verification to ' + completenumber + " ?")
                    $('select option:contains("SMS")').text('Text me at ' + completenumber);
                    $('select option:contains("Call")').text('Call me at ' + completenumber);
                    // validatePhoneNumber(Countrycode, number);
                }
                else {
                    $('#phonenumbervalidation').show();
                    $('#phonenumbervalidation').html('Please enter a valid Phone Number.')
                }
                //  CreateOneTimePassword()
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: VerifyPhoneNumeber() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }
        function validatePhoneNumber(Countrycode, number) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Account/ValidatePhoneNumber",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify
                        ({
                            Countrycode: Countrycode,
                            number: number
                        })
                })
                    .success(function (jsonResult, status) {
                        $('#loadingMainImgDiv').hide();
                        var totallength = number.substring(number.length - 3, number.length);
                        var countrycode = Countrycode + "-" + number.substring(0, 2);
                        var completenumber = countrycode + "*****" + totallength;

                        vm.OtpText("A code has been sent to you at " + completenumber + ". Enter that code below.")
                        $('#AuthenticateDiv').show();
                        $("#PhoneNumeberdiv").hide();
                        $('#MessageDiv').hide();
                    })
                    .fail(function (error, status) {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: validatePhoneNumber() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }
        function ShowPhoneNumberEntry() {
            try {
                $('#MessageDiv').hide();
                $('#PhoneNumeberdiv').show();
                $('#AuthenticateDiv').hide();
                $('#loginPageLogo').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowPhoneNumberEntry() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }

        }

        function GetPhoneNumber() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Account/GetPhoneNumberAnonymous",
                    type: "get",
                    headers: headers,
                    contentType: 'application/json',
                })
                    .success(function (jsonResult, status) {

                        if (jsonResult.length > 0 && jsonResult[0].startsWith("INC")) {
                            logger.logError(jsonResult[0] + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                        }

                        else {
                            vm.PhoneNumber(jsonResult[0]);
                            vm.MaskedNumber(jsonResult[1])
                            vm.OtpText('How should we send the MFA verification to ' + jsonResult[1] + " ?")
                            $('select option:contains("SMS")').text('Text me at ' + jsonResult[1]);
                            $('select option:contains("Call")').text('Call me at ' + jsonResult[1]);
                        }
                    })
                    .fail(function (error, status) {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetPhoneNumber() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }


        function detached() {
            try {
                $('#Masterdiv').addClass("pagelevelscroll");
                $("body").removeClass("login").addClass("login-container");
                $('body').addClass("login-page hold-transition");
                $("header").css({ "display": "block" });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }

        function SubmitOnetimepassword() {
            try {
                $('#loadingMainImgDiv').show();
                $('#OTPValidation').hide();
                vm.displayMessage('');
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Account/ValidateOTPAnonymous",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',

                    data: JSON.stringify
                        ({
                            ProviderName: vm.ProviderName(),
                            PhoneNumber: vm.PhoneNumber(),
                            Isverfiedphonenumber: appsecurity.Phonenumberverified(),
                            Token: vm.OTPPassword(),

                        })
                })
                    .success(function (jsonResult, status) {
                        if (jsonResult == true) {
                            $('#loadingMainImgDiv').hide();
                            vm.Wrongattemptcount(3);
                            $('#loginPageLogo').hide();
                            logger.logSuccess('OTP has been successfully verified.', 'Success', system.getModuleId(vm), true);

                            appsecurity.setAuthenticationInfo(vm.appsecurity.MFAat(), vm.appsecurity.MFArt(), vm.appsecurity.expMFA(), vm.appsecurity.rMe);
                            appsecurity.refreshAFToken().done(function (data) {
                                $("input[name='__RequestVerificationToken']").val(data);

                                if (appsecurity.ProjectCount() == 1) {
                                    vm.appsecurity.initializeAuth().done(function () {
                                        router.navigate('Landing');
                                    });
                                }
                                else {
                                    router.navigate('ProjectLanding');
                                }
                            });

                            //logger.logSuccess('OTP has been successfully verified.', 'Success', system.getModuleId(vm), true);
                        }
                        else {

                            $('#loadingImg').hide();
                            vm.Wrongattemptcount(vm.Wrongattemptcount() - 1);
                            $('#OTPValidation').show();
                            if (vm.Wrongattemptcount() === 2 || vm.Wrongattemptcount() === 1) {
                                $('#OTPValidation').removeClass('has-success has-error').addClass('has-warning');
                                vm.displayMessage('Please enter a valid OTP. ' + vm.Wrongattemptcount() + ' more attempt(s) left.');
                                $('#OTPValidation').show();
                            }
                            else if (vm.Wrongattemptcount() === 0) {
                                $('#OTPValidation').removeClass('has-warning has-success').addClass('has-error');
                                vm.displayMessage('You have exceeded maximum number of failure attempts. Please login back.');
                                $('#OTPValidation').show();

                                vm.appsecurity.logout()
                                    .done(function (token) {
                                        $("input[name='__RequestVerificationToken']").val(token);
                                        appsecurity.clearAuthInfo();
                                        window.location = routeconfig.login;
                                    })
                                    .fail(function (error) {
                                        appsecurity.clearAuthInfo();
                                        window.location = routeconfig.login;
                                    });
                            }

                        }

                    })
                    .fail(function (error, status) {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubmitOnetimepassword() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }


        function verifyUserwithPhonecall(data, event) {
            try {
                $('#loadingMainImgDiv').show();
                $('#loadingImg').show();
                $('#OTPValidation').hide();
                $('#OTPValidationCall').hide();

                $('#VerificationCode').hide();
                $('#btnAuthLogin').hide();
                vm.displayMessage('');
                vm.OtpText('You will receive a call on ' + vm.MaskedNumber() + ' with a verification procedure.');
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Account/verifywithcallanonymous",
                    type: "POST",
                    headers: headers,
                    data: { PhoneNumber: vm.PhoneNumber(), Isverfiedphonenumber: false, EmailId: vm.appsecurity.EmailId() }
                })
                    .success(function (jsonResult, status) {
                        if (jsonResult === true) {
                            $('#loadingMainImgDiv').hide();
                            //logger.logSuccess('User account verified successfully.', 'Success', system.getModuleId(vm), true);
                            $('#MessageDiv').hide();
                            $('#loadingMainImgDiv').hide();
                            $('#AuthenticateDiv').hide();

                            appsecurity.setAuthenticationInfo(vm.appsecurity.MFAat(), vm.appsecurity.MFArt(), vm.appsecurity.expMFA(), vm.appsecurity.rMe);
                            appsecurity.refreshAFToken().done(function (data) {
                                $("input[name='__RequestVerificationToken']").val(data);

                                if (appsecurity.ProjectCount() == 1) {
                                    vm.appsecurity.initializeAuth().done(function () {
                                        router.navigate('Landing');
                                    });
                                }
                                else {
                                    router.navigate('ProjectLanding');
                                }
                            });
                        }
                        else {
                            $('#loadingMainImgDiv').hide();
                            $('#OTPValidationCall').removeClass('has-success has-warning').addClass('has-error');
                            vm.displayMessage('Unable to verify account, Please contact Application Administrator.');
                            $('#OTPValidationCall').show();
                            $('#loadingImg').hide();
                            vm.Wrongattemptcount(vm.Wrongattemptcount() - 1);
                            if (vm.Wrongattemptcount() === 2 || vm.Wrongattemptcount() === 1) {
                                $('#OTPValidationCall').removeClass('has-success has-error').addClass('has-warning');
                                vm.displayMessage('Please use the below given link to receive another call. ' + vm.Wrongattemptcount() + ' more attempt(s) left.');
                                $('#OTPValidationCall').show();
                            }
                            else if (vm.Wrongattemptcount() === 0) {
                                $('#OTPValidationCall').removeClass('has-success has-warning').addClass('has-error');
                                vm.displayMessage('You have exceeded maximum number of failure attempts. Please login back.');
                                $('#OTPValidationCall').show();

                                vm.appsecurity.logout()
                                    .done(function (token) {
                                        $("input[name='__RequestVerificationToken']").val(token);
                                        appsecurity.clearAuthInfo();
                                        window.location = routeconfig.login;
                                    })
                                    .fail(function (error) {
                                        appsecurity.clearAuthInfo();
                                        window.location = routeconfig.login;
                                    });
                            }
                        }

                    })
                    .fail(function (error, status) {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e.statusText + ' | Source:  verifyUserwithPhonecall() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }

        function CreateOneTimePassword() {
            try {
                vm.displayMessage('');
                $('#MFAMessageLabel').hide();
                $('#OTPValidation').hide();
                $('#OTPValidationCall').hide();
                mfaType = document.getElementById('ParentQuestionDropDown').innerHTML;

                if (mfaType === 'PhoneCall') {
                    $('#MessageDiv').hide();
                    $('#loadingMainImgDiv').show();
                    $('#AuthenticateDiv').show();
                    $('#OTPdiv').hide();
                    $('#Phonecalldiv').show();
                    $('#SMSCodeMessage').hide();
                    $('#PhoneCallMessage').show();
                    verifyUserwithPhonecall();
                }
                else if (mfaType === 'Email') {
                    $('#OTPdiv').show();
                    $('#Phonecalldiv').hide();
                    $('#VerificationCode').show();
                    $('#btnAuthLogin').show();
                    $('#SMSCodeMessage').show();
                    $('#PhoneCallMessage').hide();
                    $('#loadingMainImgDiv').show();
                    verifyUserwithEmail();
                }
                else {
                    $('#OTPdiv').show();
                    $('#Phonecalldiv').hide();
                    $('#VerificationCode').show();
                    $('#btnAuthLogin').show();
                    $('#SMSCodeMessage').show();
                    $('#PhoneCallMessage').hide();

                    $('#loadingMainImgDiv').show();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;

                    $.ajax({
                        url: "/api/Account/SendOTPAnonymous",
                        type: "POST",
                        headers: headers,
                        data: { PhoneNumber: vm.PhoneNumber() }
                    })
                        .success(function (jsonResult, status) {

                            if (jsonResult.startsWith("INC")) {
                                logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                            }

                            else if (jsonResult === "true") {
                                //vm.displayMessage('OTP has been successfully sent to the registered Number.');
                                $('#OTPValidation').removeClass('has-warning has-error').addClass('has-success');
                                $('#OTPValidation').show();
                                vm.OtpText('A code has been sent to you at ' + vm.MaskedNumber() + ". Enter that code below.");
                                logger.logSuccess('OTP has been successfully sent to the registered email address.', 'Success', system.getModuleId(vm), true);

                                $('#loadingMainImgDiv').hide();
                                $('#AuthenticateDiv').show();
                                $('#MessageDiv').hide();
                                $('#OTPdiv').show();
                                $('#Phonecalldiv').hide();
                            }
                            else {
                                vm.displayMessage('Unable to send OTP, Please contact Application Administrator.');
                                $('#OTPValidation').removeClass('has-warning has-success').addClass('has-error');
                                $('#MFAMessageLabel').show();
                                logger.logError('Unable to send OTP, Please contact Application Administrator.', 'Error', system.getModuleId(vm), true);

                            }

                        })
                        .fail(function (error, status) {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                            logger.logMessage(msg);
                        });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreateOneTimePassword() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }
        function ResendOTP() {
            try {
                //CreateOneTimePassword();
                verifyUserwithEmail();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubmitOnetimepassword() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }

        function verifyUserwithEmail() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Account/SendMailOTPAnonymous",
                    type: "POST",
                    headers: headers,
                })
                    .success(function (jsonResult, status) {
                        if (jsonResult != "" || jsonResult != undefined) {
                            $('#OTPValidation').removeClass('has-warning has-error').addClass('has-success');
                            $('#OTPValidation').show();
                            vm.OtpText('A code has been sent to you at ' + jsonResult + ". Enter that code below.");
                            logger.logSuccess('OTP has been successfully sent to the registered email address.', 'Success', system.getModuleId(vm), true);


                            $('#loadingMainImgDiv').hide();
                            $('#AuthenticateDiv').show();
                            $('#MessageDiv').hide();
                            $('#OTPdiv').show();
                            $('#Phonecalldiv').hide();
                        }
                        else {
                            vm.displayMessage('Unable to send OTP, Please contact Application Administrator.');
                            $('#OTPValidation').removeClass('has-warning has-success').addClass('has-error');
                            $('#MFAMessageLabel').show();
                            logger.logError('Unable to send OTP, Please contact Application Administrator.', 'Error', system.getModuleId(vm), true);

                        }

                    })
                    .fail(function (error, status) {
                        $('#loadingMainImgDiv').hide();
                        $('#AuthenticateDiv').show();
                        $('#MessageDiv').hide();
                        $('#OTPdiv').show();
                        $('#Phonecalldiv').hide();
                        logger.logError('Unable to send OTP, Please contact Application Administrator.', 'Error', system.getModuleId(vm), true);

                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubmitOnetimepassword() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }

        function GetContactUsInformation() {
            try {
                var headers = appsecurity.getSecurityHeaders();
                return $.ajax({
                    url: "/api/Configuration/GetUserSupportItem",
                    type: "GET",
                    headers: headers,
                    data: { TypeId: 14 }//14 is the id for contact us data}
                })
                    .success(function (jsonResult, error) {

                        if (jsonResult.Incident_Description != null && jsonResult.Incident_Description.startsWith("INC")) {
                            logger.logError(jsonResult.Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                        }

                        if (jsonResult.length == 0)
                            logger.logError('No data available for Contact us.', 'Warning', system.getModuleId(vm), true);

                        vm.appsecurity.ContanctUs('No contact information available.');
                        if (jsonResult.length != 0) {
                            if (jsonResult.Description != null && jsonResult.Description != undefined)
                                vm.appsecurity.ContanctUs(jsonResult.Description);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the User support. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetContactInformation() method in header.js';
                logger.logMessage(msg);
            }
        }

        function ShowGeneralManual(data) {
            try {
                vm.UserContent(data);
                hideAll();
                $("#MessageDivbtn").show();
                if (data != undefined) {

                    switch (data) {
                        case 'GeneralUserSupport':
                            $("#guide-content").show();
                            break;
                        case 'Privacy':
                            $("#privacy-content").show();
                            break;
                        case 'Cookies':
                            $("#cookies-content").show();
                            break;
                        case 'Terms':
                            $("#terms-content").show();
                            break;
                        case 'faqList':
                            $("#mainFaq-content").show();
                            break;
                        case 'MFA':
                            $("#MessageDiv").show();
                            $("#MessageDivbtn").hide();
                            $('#AuthenticateDiv').hide();
                            break;
                        default:
                            $("#MessageDiv").show();
                            $("#MessageDivbtn").hide();
                            break;
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowGeneralUserGuide() method in UserManual.js';
                logger.logMessage(msg);
            }
        }

        function hideAll() {
            $("#mainFaq-content").hide();
            $("#cookies-content").hide();
            $("#privacy-content").hide();
            $("#guide-content").hide();
            $("#terms-content").hide();
            $("#forgotPwd-content").hide();
            $("#changePhone-Pwd-content").hide();
            $("#MessageDiv").hide();
            $("#MessageDivbtn").hide();
        }

    });



